import type { SelectItemKeyed } from 'common/types'

import { MAX_GRID_NODES } from '../constants'
import type {
  ExtrapolationMethodItemsType,
  InterpolationItemsType,
  InterpolationMethodItemsType,
  TypeOfCalculationType,
  WeightCoefficientItemsType,
} from './types'

export const maxSelectItemLength = 10
export const interpolationItems: InterpolationItemsType[] = [
  { label: 'Билинейная', key: 'Bilinear' },
  { label: 'Бикубическая', key: 'Bicubic' },
]
export const smoothingCore: SelectItemKeyed[] = [
  { label: '3x3', key: '3x3' },
  { label: '5x5', key: '5x5' },
]
export const initialApproximations: SelectItemKeyed[] = [
  { label: '2', key: '2' },
  { label: '4', key: '4' },
  { label: '8', key: '8' },
  { label: '16', key: '16' },
  { label: '32', key: '32' },
]
export const typeOfCalculation: TypeOfCalculationType[] = [
  { label: 'Точный', key: 'Accurate' },
  { label: 'Грубый', key: 'Fast' },
  { label: 'Экспресс', key: 'FastFast' },
]

export const interpolationMethods: InterpolationMethodItemsType[] = [
  { label: 'Среднее значение', key: 'MeanValue' },
]
export const weightCoefficients: WeightCoefficientItemsType[] = [
  { label: 'Одинаковый для всех точек', key: 'Equals' },
]
export const extrapolationMethods: ExtrapolationMethodItemsType[] = [
  { label: 'Минимальная кривизна', key: 'MinimalCurvature' },
]

export const ERROR_TEXT = `Карта не может рассчитать более ${MAX_GRID_NODES} узлов, увеличьте шаг или уменьшите границы`
